import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-chat-message-list-ordered',
  templateUrl: './chat-message-list-ordered.component.html',
  styleUrls: ['./chat-message-list-ordered.component.scss']
})
export class ChatMessageListOrderedComponent implements OnInit {

  @Input() index: number;
  @Input() elements: any;

  constructor() { }

  ngOnInit() { }

}
